import { t } from "@repo/translation";
import { getDay } from "date-fns";

interface Props {
  date: string | Date;
}

const dayMap = {
  0: "label.sunday",
  1: "label.monday",
  2: "label.tuesday",
  3: "label.wednesday",
  4: "label.thursday",
  5: "label.friday",
  6: "label.saturday",
};

export const LocalizedWeekday = ({ date }: Props) => (
  <>{localizeWeekday(date)}</>
);

export const localizeWeekday = (date: string | Date) => {
  const d = date instanceof Date ? date : new Date(date);
  const weekDayNumber = getDay(d) as 0 | 1 | 2 | 3 | 4 | 5 | 6;
  return t(dayMap[weekDayNumber]);
};
